import React from "react";

export default function CookiesLink (){
        return(
            
<a href="https://www.iubenda.com/privacy-policy/25482128" 
className="iubenda-white iubenda-embed " 
title="Privacy Policy">Política de Privacidad y Cookies</a> 
        )
}



// WEBPACK FOOTER //
// ./src/components/Linking/cookiesLink.js